import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryProvider } from './lib/queryClient';
import { RoutedApp } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { installAppLifecycleTracking } from './lib/appLifecycle';
import { installCrashDiagnostics } from './lib/crashDiagnostics';
import './styles.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('[service-companion] service worker registration failed', error);
    });
  });
}

installAppLifecycleTracking();
installCrashDiagnostics();

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <RoutedApp />
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>
);
